var _path, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStlIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1797 28H21.8203C23.9328 28 25 26.8738 25 24.6776V14.1136C25 12.8972 24.8475 12.3566 24.1289 11.5908L17.726 4.90099C17.029 4.16893 16.4628 4 15.4065 4H10.1797C8.08893 4 7 5.11497 7 7.31112V24.6776C7 26.8738 8.07804 28 10.1797 28ZM10.245 26.6035C8.99274 26.6035 8.35027 25.9165 8.35027 24.6438V7.34491C8.35027 6.10605 8.99274 5.38527 10.2559 5.38527H15.3412V12.1652C15.3412 13.4491 15.9728 14.0573 17.1815 14.0573H23.6606V24.6438C23.6606 25.9165 23.0073 26.6035 21.755 26.6035H10.245ZM17.323 12.7396C16.8221 12.7396 16.6152 12.5368 16.6152 12.0188V5.66682L23.3884 12.7396H17.323Z",
    fill: "currentcolor"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 16,
    y: 23,
    fontFamily: "Arial, sans-serif",
    fontSize: 7,
    fontWeight: 600,
    fill: "currentcolor",
    textAnchor: "middle"
  }, "STL")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStlIcon);
export default __webpack_public_path__ + "static/media/stl-icon.293631cc2d61a3e31b466b0588c0a226.svg";
export { ForwardRef as ReactComponent };